import { doDelete, doGet, doPost, doPut } from "../../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { setTableLoading } from '../../../store/reducer/page.reducer'
import { checkValidationToken } from "../../../util/errorHandler";

export const getVehicleList = async (token, refresh_token, param, dispatch) => {
    const url = `${GROLOG_URL}/vehicle?${param}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getDetailVehicle = async (token, refresh_token, id, dispatch) => {
    const url = `${GROLOG_URL}/vehicle/${id}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getMaxOrderUnit = async (token, refresh_token, param, dispatch) => {
    const url = `${GROLOG_URL}/grolog-parameter/5?${param}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const postVehicle = async (token, refresh_token, data, dispatch) => {
    const url = `${GROLOG_URL}/vehicle?CLIENT_ID=1231278asdbaiaerrs&RESOURCE_USER_ID=13&GROLOG_ACCOUNT_ID=1`
    let result = { data: undefined, ok: false }

    try {
        const response = await doPost(url, token, data)
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
        result.code = error.response?.data?.payload?.code
        result.message = error.response?.data?.payload?.message
    }
    return result
}

export const getSearchRecommendation = async (token, refresh_token, depot_id, keyword, dispatch) => {
    const url = `${GROLOG_URL}/vehicle/search?page=1&limit=100&filter=depot_id eq ${depot_id}, vehicle_type lk ${keyword}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getSearchResult = async (token, refresh_token, depot_id, keyword, dispatch) => {
    const url = `${GROLOG_URL}/vehicle?page=1&limit=100&filter=depot_id eq ${depot_id}, vehicle_type eq ${keyword}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getListSkillsetDropdown = async (token, refresh_token, param, dispatch) => {
    const url = `${GROLOG_URL}/skill-set/dropdown`
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, param);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getListTemperatureCategoryDropdown = async (token, refresh_token, param, dispatch) => {
    const url = `${GROLOG_URL}/temperature-category/dropdown`
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, param);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const initiateVehicle = async (token, refresh_token, param, dispatch) => {
    const url = `${GROLOG_URL}/vehicle/initiate?${param}`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const deleteVehicle = async (token, refresh_token, id, updated_at, dispatch) => {
    const url = `${GROLOG_URL}/vehicle/${id}`
    let result = { data: undefined, ok: false }

    let data = {
        'updated_at': updated_at
    }

    try {
        const response = await doDelete(url, token, data)
        if (response) {
            result.ok = true
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getListVehicleDropdown = async (token, page, keyword, refresh_token, dispatch) => {
    const params = {
        page: page,
        limit: 10,
        order: 'id asc',
        filter: keyword !== '' ? `depot_name lk ${keyword}` : ''
    }
    const url = `${GROLOG_URL}/depot-list-filter`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, params);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const editVehicle = async (token, refresh_token, id, data, dispatch) => {
    const url = `${GROLOG_URL}/vehicle/${id}`
    let result = { data: undefined, ok: false }

    try {
        const response = await doPut(url, token, data)
        if (response) {
            result.ok = true
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
        result.code = error.response?.data?.payload?.code
        result.message = error.response?.data?.payload?.message
    }
    return result
}

export const getListVehicleAdditionalProofs = async (token, refresh_token, dispatch) => {
    const url = `${GROLOG_URL}/additional-proofs?page=1&filter=to_menu eq Vehicle`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const getManagementHistoryList = async (token, refresh_token, dispatch, id) => {
    const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq vehicle, primary_key eq ${id}`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}